module.exports = __webpack_public_path__ + "static/contacto-c605930afdca766a1a69b5da98e49048.svg";